import { OrderStatus } from '../enums';
import { Address } from './address';
import { Log } from './log';
import { OrderProducts } from './order-products';
import { ShipmentMethod } from './shipment';
import { User } from './user';

export interface OrderFile {
    name: string;
    url: string;
}

export interface Order extends Log {
    id?: any;

    /**
     * @description User id a valid mongo id taken from cart
     */
    user: User;

    /**
     * @description Products taken from cart products. Every product have quantity and price
     */
    products: OrderProducts[];

    /**
     * @description Order status is Created when order is first time emitted.
     */
    status: OrderStatus;

    /**
     * The woo commerce order id corespondent
     */
    wooOrderId?: number;

    /**
     * The woo order object
     */
    wooOrder: any;

    // UI ONLY PROPERTIES
    subtotal?: number;
    shippingMethod?: string;
    paymentMethod?: string;
    wooNumber?: string;
    productCount?: number;
    proformaInvoiceUrl?: string;
    invoiceUrl?: string;
    paymentUrl?: string;
    shippingAddress?: any;
    billingAddress?: any;

    // new properties to populate
    courier?: string;
    AWB?: string;
    trackingUrl?: string;
    shipmentCost?: number;
    totalCost?: number;
    hasVouchers?: boolean;
    costWithoutVouchers?: number;
    documents: OrderFile[];
}

export interface OrderFromCart {
    shipmentMethod: ShipmentMethod;
    billingAddress: Address;
    shippingAddress: Address;
}
